import ApplyForm from 'views/apply-form';

// Routes accessible without any authentication
const PublicRoutes = {
    path: ':slug/apply',
    element: <ApplyForm />,
};

export default PublicRoutes;
